import { z } from 'zod';

const monthValue = z.string().regex(/^\d{4}-\d{2}$/, 'Mês inválido');

export const PlanningFormSchema = z.object({
	method: z.enum(['irrigation', 'broad'], { error: 'Método de aplicação é obrigatório' }),
	startMonth: monthValue,
	endMonth: monthValue,
	vbox: z.string(),
	cemMax: z.string(),
	injectorFlow: z.string(),
	packId: z.string(),
	saltFraction: z.string(),
	desiredEventsPerMonth: z.string(),
});

export const createPlanningSchema = (planMonths: string[]) =>
	PlanningFormSchema.superRefine((data, ctx) => {
		if (data.startMonth > data.endMonth) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth'],
				message: 'Mês final deve ser igual ou posterior ao mês inicial',
			});
		}

		if (!planMonths.includes(data.startMonth)) {
			ctx.addIssue({
				code: 'custom',
				path: ['startMonth'],
				message: 'Mês inicial não está no plano de adubação',
			});
		}

		if (!planMonths.includes(data.endMonth)) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth'],
				message: 'Mês final não está no plano de adubação',
			});
		}

		if (data.method !== 'irrigation') return;

		if (!data.packId) {
			ctx.addIssue({
				code: 'custom',
				path: ['packId'],
				message: 'Pacote de produtos é obrigatório',
			});
		}

		const vbox = Number(data.vbox);
		if (!data.vbox || !Number.isFinite(vbox) || vbox <= 0) {
			ctx.addIssue({
				code: 'custom',
				path: ['vbox'],
				message: 'Volume da caixa de injeção deve ser maior que 0.',
			});
		}

		const cemMax = Number(data.cemMax);
		if (!data.cemMax || !Number.isFinite(cemMax) || cemMax <= 0) {
			ctx.addIssue({
				code: 'custom',
				path: ['cemMax'],
				message: 'Concentração permitida deve ser maior que 0.',
			});
		}

		const injectorFlow = Number(data.injectorFlow);
		if (!data.injectorFlow || !Number.isFinite(injectorFlow) || injectorFlow <= 0) {
			ctx.addIssue({
				code: 'custom',
				path: ['injectorFlow'],
				message: 'Vazão do injetor deve ser maior que 0.',
			});
		}

		const saltPercent = Number(data.saltFraction);
		if (!data.saltFraction || !Number.isFinite(saltPercent) || saltPercent <= 0 || saltPercent > 100) {
			ctx.addIssue({
				code: 'custom',
				path: ['saltFraction'],
				message: 'Fração de sais deve ser maior que 0 e no máximo 100%.',
			});
		}

		if (data.desiredEventsPerMonth) {
			const desiredEvents = Number(data.desiredEventsPerMonth);
			if (!Number.isInteger(desiredEvents) || desiredEvents <= 0 || desiredEvents > 12) {
				ctx.addIssue({
					code: 'custom',
					path: ['desiredEventsPerMonth'],
					message: 'Eventos por mês deve ser um inteiro entre 1 e 12.',
				});
			}
		}
	});

export type PlanningSchemaType = z.infer<typeof PlanningFormSchema>;
